<template lang="pug">
    svg(width="52" height="52" viewBox="0 0 52 52" fill="none")
        path( d="M25.9998 42.6097C35.1738 42.6097 42.6109 35.1727 42.6109 25.9986C42.6109 16.8245 35.1738 9.38748 25.9998 9.38748C16.8257 9.38748 9.38867 16.8245 9.38867 25.9986C9.38867 35.1727 16.8257 42.6097 25.9998 42.6097Z" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round")
        path( d="M33.088 32.3581C28.8621 35.7585 22.9044 35.7437 18.9111 32.3581" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round")
        path( d="M29.1094 22.0955C29.8748 23.8183 31.8919 24.5944 33.6146 23.829C34.3872 23.4858 35.0048 22.8681 35.3481 22.0955" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round")
        path( d="M16.6514 22.0955C17.4168 23.8183 19.4339 24.5944 21.1566 23.829C21.9291 23.4858 22.5468 22.8681 22.8901 22.0955" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round")
        path( d="M15.7793 19.6033C16.3903 18.4285 17.4138 17.5227 18.654 17.0599C19.8454 16.4662 21.2149 16.3404 22.4949 16.703" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round")
        path( d="M37.3985 19.6033C36.0572 17.2528 33.3258 16.0679 30.6929 16.6948" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round")
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            color: VueTypes.string.def('#cecece')
        }
    };
</script>
